var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"cad"},[_c('span',{staticClass:"cad-icon"}),_c('span',{staticClass:"cad-title"},[_vm._v(" "+_vm._s(_vm.data.title)+" "),_c('small',{staticClass:"cad-description"},[_vm._v(_vm._s(_vm.data.description))])]),_c('span',{staticClass:"cad-quantity"},[_vm._v(_vm._s(_vm.data.quantity))])])
}
var staticRenderFns = []

export { render, staticRenderFns }